import axios from 'axios'
import TransactionSchema, {
  AdminTransactionsSchema,
  AdminTransactionsSchemaType,
  PaginatedTransactions,
} from '@/queries/transactions/transactions.types.ts'

const TransactionsQueryKeys = {
  list_all: ['transactions'],
  paginateTransactions: (
    program_id: number,
    recordsPerPage: number,
    currentPage: number,
    global_on_id: number,
    locale = 'en'
  ) => [
    ...TransactionsQueryKeys.list_all,
    program_id,
    recordsPerPage,
    currentPage,
    global_on_id,
    locale,
  ],
} as const

export const getPaginatedTransactions = async (
  program_id: number,
  currentPage: number,
  recordsPerPage: number,
  global_on_id: number,
  locale: string,
  search: string
): Promise<PaginatedTransactions> => {
  const response = await axios.get('/transactions', {
    params: {
      program_id,
      paginate: 1,
      per_page: recordsPerPage,
      page: currentPage,
      global_on_id,
      i18n: locale,
      search,
    },
  })
  return response.data
}

export const getTransactionById = async (
  transaction_id: number,
  program_id: number
) => {
  const response = await axios.get(`/transactions/${transaction_id}`, {
    params: {
      program_id,
    },
  })
  return TransactionSchema.parse(response.data)
}

type Identifier = { provider_id: number } | { applicant_id: number }

export const getTransactionsAdmin = async (
  program_id: number,
  recordsPerPage: number,
  global_on_id: number,
  locale: string,
  identifier: Identifier
): Promise<AdminTransactionsSchemaType> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const params: Record<string, any> = {
    program_id,
    paginate: 1,
    per_page: recordsPerPage,
    global_on_id,
    i18n: locale,
    ...identifier,
  }
  const response = await axios.get('/transactions', { params })
  return AdminTransactionsSchema.parse(response.data)
}
